export const Severity = Object.freeze({
  SEVERE: 1,
  WARNING: 2,
  ALERT: 3,
  NOT_IN_FORCE: 4,
})

export const DisplaySeverity = Object.freeze({
  1: 'Severe Warning',
  2: 'Warning',
  3: 'Alert',
  4: 'No longer active',
})
